<template>
  <div class="product-content">
    <el-dialog title="升级申请审核" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="common-form">基本信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="10">
            <div class="pb16">
              <span class="gray9">昵称：</span>
              {{ detail.user.nickName }}
            </div>
          </el-col>
          <el-col :span="10">
            <div class="pb16">
              <span class="gray9">手机：</span>
              {{ detail.user.mobile }}
            </div>
          </el-col>
          <el-col :span="10">
            <div class="pb16">
              <span class="gray9">当前等级：</span>
                {{ detail.oldgrade?detail.oldgrade.name:'' }}
            </div>
          </el-col>
          <el-col :span="10">
            <div class="pb16">
              <span class="gray9">拟申请等级：</span>
                {{ detail.grade?detail.grade.name:'' }}
            </div>
          </el-col>
          <el-col :span="10">
            <div class="pb16">
              <span class="gray9">申请时间：</span>
              {{ detail.create_time }}
            </div>
          </el-col>
          <el-col :span="10">
            <div class="pb16">
              <span class="gray9">支付费用 (元)：</span>
              {{ detail.pay_price }}
            </div>
          </el-col>
          <el-col :span="10">
            <div class="pb16">
              <span class="gray9">支付方式：</span>
              {{ detail.pay_text }}
            </div>
          </el-col>
        </el-row>
      </div>
      
      <div class="common-form">审核操作</div>
      <el-form :model="formData" ref="formRef">
        <el-form-item label="审核状态" :label-width="formLabelWidth">
          <div>
            <el-radio-group v-model="formData.order_status">
              <el-radio :label="10">待审核</el-radio>
              <el-radio :label="30">审核通过</el-radio>
              <el-radio :label="20">拒绝</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        
        <!-- 审核通过时显示赠送短信数量 -->
        <el-form-item label="赠送短信数量" v-if="formData.order_status==30" :label-width="formLabelWidth">
          <el-input 
            v-model.number="formData.gift_sms_count" 
            type="number"
            min="0"
            placeholder="请输入赠送的短信数量">
            <template slot="append">条</template>
          </el-input>
        </el-form-item>
        
        <!-- 拒绝时显示原因和退款状态 -->
        <el-form-item label="原因" v-if="formData.order_status==20" :label-width="formLabelWidth">
          <el-input v-model="formData.reject_reason" autocomplete="off"></el-input>
        </el-form-item>
        
        <div v-if="formData.order_status==20">
          <el-form-item label="审核状态" :label-width="formLabelWidth">
            <div>
              <el-radio-group v-model="formData.reject_status">
                <el-radio :label="10">无操作</el-radio>
                <el-radio :label="20">待退款</el-radio>
                <el-radio :label="30">已退款</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </div>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="editApplyStatus">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';
export default {
  data() {
    return {
      formData: {
        order_status: 10,
        gift_sms_count: 0,
        reject_reason: '',
        reject_status: 10
      },
      detail: {},
      certification: {
        name: '',
        certificate_no: '',
        front_idcard: '',
        back_idcard: '',
        business_license: '',
      },
      status: '',
      formLabelWidth: '200px',
      dialogVisible: false
    };
  },
  props: ['open_edit', 'form'],
  watch: {
    form: {
      handler(newVal) {
        this.initFormData(newVal);
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.dialogVisible = this.open_edit;
    this.initFormData(this.form);
    this.status = this.form.order_status;
    this.getCertification();
  },
  methods: {
    /*初始化表单数据*/
    initFormData(form) {
      if (form) {
        this.formData = {
          ...this.formData,
          ...form,
          // 确保 gift_sms_count 有值
          gift_sms_count: form.gift_sms_count || 0
        };
        this.detail = form;
      }
    },
    
    /*修改用户*/
    editApplyStatus() {
      let self = this;
      
      // 验证赠送短信数量（如果审核通过）
      if (this.formData.order_status == 30) {
        if (this.formData.gift_sms_count === '' || this.formData.gift_sms_count === null) {
          self.$message({
            message: '请输入赠送短信数量',
            type: 'warning'
          });
          return;
        }
        
        if (this.formData.gift_sms_count < 0) {
          self.$message({
            message: '赠送短信数量不能为负数',
            type: 'warning'
          });
          return;
        }
      }
      
      console.log('提交的数据:', this.formData);
      PlusApi.editGradeOrderStatus(this.formData, true)
        .then(data => {
          self.$message({
            message: '恭喜你，修改成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          console.error('提交失败:', error);
        });
    },
    
    /*获取实名认证信息*/
    getCertification() {
      let self = this;
      let user_id = self.detail.user_id;
      PlusApi.certifyDetail({user_id: user_id}, true)
        .then(data => {
          self.certification = data.data.detail;
        })
        .catch(error => {});
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false,
          formData: this.formData
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style>
.el-dialog__body{
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/views/user/setting/part/Edit.vue